import { ExamDetail } from "./exam-detail";
import { Price } from "./form/price";
export class Session {
    constructor(examSessionWrapper, certificateId, button, examId) {
        this.examSessionWrapper = examSessionWrapper;
        this.certificateId = certificateId;
        this.button = button;
        this.examId = examId;
        this.examDetails = [];
    }
    addSession() {
        if (this.examSessionWrapper.innerHTML !== "") {
            return;
        }
        this.button.classList.add("hidden");
        const element = this.createSessionFromTemplate(this.examId);
        this.examSessionWrapper.appendChild(element);
        this.price = new Price(this.examSessionWrapper);
        this.addDetail();
        this.examSessionWrapper
            .querySelector(Session.addDetailButtonSelector)
            .addEventListener("click", () => this.addDetail());
    }
    addDetail() {
        this.examDetails.push(new ExamDetail(this.certificateId, this.examId, (detailRemoved) => this.removeDetail(detailRemoved), this.examSessionWrapper.querySelector(Session.examDetailWrapperSelector)));
    }
    createSessionFromTemplate(examId) {
        const template = document.getElementById(Session.templateId);
        const element = document.importNode(template.content, true);
        element.childNodes.forEach((node) => {
            if (node instanceof HTMLElement) {
                node.innerHTML = node.innerHTML
                    .replace(/%examId%/g, examId)
                    .replace(/%certificateId%/g, this.certificateId);
            }
        });
        return element;
    }
    activate() {
        this.addSession();
    }
    deactivate() {
        this.examSessionWrapper.innerHTML = "";
        this.button.classList.remove("hidden");
    }
    removeDetail(detailRemoved) {
        this.examDetails = this.examDetails.filter((detail) => detail !== detailRemoved);
        if (this.examDetails.length === 0) {
            this.examSessionWrapper.innerHTML = "";
            this.button.classList.remove("hidden");
        }
    }
    addToFormData(formData) {
        if (!this.isActive()) {
            return;
        }
        this.examDetails.forEach((detail) => detail.addToFormData(formData));
        this.price.addToFormData(formData);
    }
    validate() {
        return (!this.isActive() ||
            (this.price.validate() &&
                this.examDetails.every((detail) => detail.validate())));
    }
    isActive() {
        return this.examSessionWrapper.innerHTML !== "";
    }
}
Session.examDetailWrapperSelector = ".js-detail-sessions";
Session.templateId = "exam-template";
Session.addDetailButtonSelector = ".js-add-detail";
